exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_OrgAssetContainer_1wqscaKPz8Oa2dQGlXNTgm {\n  display: flex;\n  flex-direction: column;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.IA_OrgAssetItemsContainer_1MWaE_MwkDzd4gIjBU5Myj {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.IA_OrgAssetErrorMessage_289eWOaz9sKTKnwGeX7Gjr {\n  padding-top: 15px;\n  font-size: 16px;\n}", ""]);

// Exports
exports.locals = {
	"IA_OrgAssetContainer": "IA_OrgAssetContainer_1wqscaKPz8Oa2dQGlXNTgm",
	"IA_OrgAssetItemsContainer": "IA_OrgAssetItemsContainer_1MWaE_MwkDzd4gIjBU5Myj",
	"IA_OrgAssetErrorMessage": "IA_OrgAssetErrorMessage_289eWOaz9sKTKnwGeX7Gjr"
};